import React from 'react';

// Utils
import { SCHEMA_TYPE_MULTI_ENUM, SCHEMA_TYPE_TEXT, SCHEMA_TYPE_YOUTUBE } from '../../util/types';
import {
  isFieldForCategory,
  pickCategoryFields,
  pickCustomFieldProps,
} from '../../util/fieldHelpers.js';

import SectionDetailsMaybe from './SectionDetailsMaybe';
import SectionTextMaybe from './SectionTextMaybe';
import SectionYoutubeVideoMaybe from './SectionYoutubeVideoMaybe';

/**
 * Renders custom listing fields.
 * - SectionDetailsMaybe is used if schemaType is 'enum', 'long', or 'boolean'
 * - SectionMultiEnumMaybe is used if schemaType is 'multi-enum'
 * - SectionTextMaybe is used if schemaType is 'text'
 *
 * @param {*} props include publicData, metadata, listingFieldConfigs, categoryConfiguration
 * @returns React.Fragment containing aforementioned components
 */
const CustomListingFields = props => {
  const { publicData, metadata, listingFieldConfigs, categoryConfiguration } = props;

  const { key: categoryPrefix, categories: listingCategoriesConfig } = categoryConfiguration;
  const categoriesObj = pickCategoryFields(publicData, categoryPrefix, 1, listingCategoriesConfig);
  const currentCategories = Object.values(categoriesObj);

  const isFieldForSelectedCategories = fieldConfig => isFieldForCategory(currentCategories, fieldConfig);

  const propsForCustomFields =
    pickCustomFieldProps(
      publicData,
      metadata,
      listingFieldConfigs,
      'listingType',
      isFieldForSelectedCategories
    ) || [];

  // Exclude these field keys from being rendered
  const excludedFieldKeys = ['league_id', 'club_id', 'player_id', 'country_id', 'season_id', 'for_sale_option'];

  const visibleCustomFields = propsForCustomFields.filter(f => !excludedFieldKeys.includes(f.key));

  return (
    <>
      <SectionDetailsMaybe {...props} isFieldForCategory={isFieldForSelectedCategories} excludedFieldKeys={excludedFieldKeys} />
      {visibleCustomFields.map(customFieldProps => {
        const { schemaType, key, ...fieldProps } = customFieldProps;

        let updatedHeading = fieldProps.heading;

        if (key === 'player' && fieldProps.text) {
          updatedHeading = 'Spieler';
        }

        return schemaType === SCHEMA_TYPE_MULTI_ENUM ? (
          (() => {
            const { options = [], selectedOptions = [] } = fieldProps;
            const selectedLabels = options
              .filter(o => selectedOptions.includes(o.key))
              .map(o => o.label);
            const text = selectedLabels.join(', ');
            return text ? (
              <SectionTextMaybe key={key} heading={updatedHeading} text={text} />
            ) : null;
          })()
        ) : schemaType === SCHEMA_TYPE_TEXT ? (
          <SectionTextMaybe key={key} {...fieldProps} heading={updatedHeading} />
        ) : schemaType === SCHEMA_TYPE_YOUTUBE ? (
          <SectionYoutubeVideoMaybe key={key} {...fieldProps} />
        ) : null;
      })}
    </>
  );
};

export default CustomListingFields;
